module.exports = __webpack_public_path__ + "static/media/digital-ocean.f13b936c.svg";